<template>
  <div class="right">
    <div class="common-tab-heads grzxxx_tab">
      <!--        <div class="line"></div>-->
      <div class="nav">
        <span
          class="grzxxx_tabs"
          :class="item.id == currentNav ? 'active' : ''"
          v-for="(item, index) in navList"
          :key="index"
          @click="currentNavChange(item)"
          >{{ item.name }}</span
        >
      </div>
    </div>

    <section class="jlxx_zwpj" v-if="currentNav == 'grpj'">
      <div class="grzx_common_title">个人评价</div>
      <span class="zwpj_button" @click="editGrpj()">保存</span>
      <textarea
        placeholder="请输入个人评价"
        rows="4"
        maxlength="200"
        v-model="studentInfo.introduce"
      ></textarea>
    </section>

    <section class="jlxx_qzyx jlxx_line" v-if="currentNav == 'qzyx'">
      <div class="grzx_common_title">求职意向</div>
      <div class="qzyx_moudle">
        <div
          class="jlxx_moudle_one"
          @mouseover="mouseOver('qzyx')"
          @mouseleave="mouseLeave('qzyx')"
          v-for="(item, index) in qzyxList"
          :key="index"
        >
          <div class="jlxx_moudle_first_line">
            <div class="jlxx_moudle_title">{{ item.position }}</div>
            <div
              class="jlxx_moudle_button"
              :class="btns.qzyx ? 'showEdit' : 'showEdit'"
            >
              <p @click="changeFormShow(item, 'qzyx')">修改</p>
            </div>
          </div>
          <div class="qzyx_content">
            <div class="qzyx_content_one" style="width: 34.6%">
              期望行业：<span>{{ item.industry }}</span>
            </div>
            <div class="qzyx_content_one">
              期望工作地点：<span>{{ item.address }}</span>
            </div>
            <div class="qzyx_content_one">
              期望薪资（元/月）：<span>{{ item.salary }}</span>
            </div>
            <div class="qzyx_content_one" style="width: 34.6%">
              工作经验（年）：<span>{{ item.workYear }}</span>
            </div>
            <div class="qzyx_content_one">
              工作性质：<span>{{
                item.workType == 1
                  ? "全职"
                  : item.workType == 2
                  ? "兼职"
                  : item.workType == 3
                  ? "实习"
                  : ""
              }}</span>
            </div>
          </div>
        </div>

        <div class="jlxx_form" v-if="formShow.qzyx">
          <div class="rczp-row">
            <div class="rczp-col rczp-col-2">
              <span class="rczp-form-label">期望职位：</span>
              <input
                placeholder="请输入"
                v-model="form.qzyx.position"
                class="rczp-form-input"
              />
            </div>
            <div class="rczp-col rczp-col-2">
              <span class="rczp-form-label">期望行业：</span>
              <input
                placeholder="请输入"
                v-model="form.qzyx.industry"
                class="rczp-form-input"
              />
            </div>
          </div>
          <div class="rczp-row">
            <div class="rczp-col rczp-col-2">
              <span class="rczp-form-label"
                ><span>期望：<br />工作地点&nbsp;&nbsp;&nbsp;</span></span
              >
              <input
                placeholder="请输入"
                v-model="form.qzyx.address"
                class="rczp-form-input"
              />
            </div>
            <div class="rczp-col rczp-col-2">
              <span class="rczp-form-label"
                ><span>期望薪资：<br />(元/月)&nbsp;&nbsp;</span></span
              >
              <input
                placeholder="请输入"
                v-model="form.qzyx.salary"
                class="rczp-form-input"
                type="number"
                min="0"
              />
            </div>
          </div>
          <div class="rczp-row">
            <div class="rczp-col rczp-col-2">
              <span class="rczp-form-label"
                ><span
                  >工作经验：<br />（年）&nbsp;&nbsp;&nbsp;&nbsp;</span
                ></span
              >
              <input
                placeholder="请输入"
                class="rczp-form-input"
                id="gzjy"
                name="gzjy"
                type="number"
                min="0"
                v-model="form.qzyx.workYear"
              />
            </div>
            <div class="rczp-col rczp-col-2">
              <span class="rczp-form-label">工作性质：</span>
              <div>
                <div>
                  <input
                    type="radio"
                    name="gzxz"
                    id="gzxz01"
                    class="jlxx_radio"
                    style="margin-left: 20px"
                    value="1"
                    v-model="form.qzyx.workType"
                  />
                  <label class="jlxx_radio_label" for="gzxz01">全职</label
                  ><input
                    type="radio"
                    name="gzxz"
                    id="gzxz02"
                    class="jlxx_radio"
                    style="margin-left: 20px"
                    value="2"
                    v-model="form.qzyx.workType"
                  />
                  <label class="jlxx_radio_label" for="gzxz02">兼职</label
                  ><input
                    type="radio"
                    name="gzxz"
                    id="gzxz03"
                    class="jlxx_radio"
                    style="margin-left: 20px"
                    value="3"
                    v-model="form.qzyx.workType"
                  />
                  <label class="jlxx_radio_label" for="gzxz03">实习</label>
                </div>
              </div>
            </div>
          </div>
          <div class="jlxx_btn">
            <button
              type="button"
              class="common-btn my-btn"
              style="background-color: rgba(241, 83, 82, 1)"
              @click="moudleCancel('qzyx')"
            >
              取消
            </button>
            <button
              type="button"
              class="common-btn my-btn"
              @click="moudleOk('qzyx')"
            >
              保存更新
            </button>
          </div>
        </div>
      </div>
      <div
        class="grzx_common_add_button jlxx_add_button"
        data-type="qzyx"
        @click="changeFormShow(null, 'qzyx')"
        v-if="addShow.qzyx"
      >
        + 添加求职意向
      </div>
    </section>

    <section class="jlxx_jyjl jlxx_line" v-if="currentNav == 'jyjl'">
      <div class="grzx_common_title">教育经历</div>
      <div class="jyjl_moudle">
        <div
          class="jlxx_moudle_one"
          @mouseover="mouseOver('jyjl')"
          @mouseleave="mouseLeave('jyjl')"
          v-for="(item, index) in jyjlList"
          :key="index"
        >
          <div class="jlxx_moudle_first_line">
            <div class="jlxx_moudle_title">{{ item.schoolName }}</div>
            <div class="jyjl_content_one" style="min-width: 150px">
              {{ item.education }}
            </div>
            <div class="jyjl_content_one jyjl_content_one_more">
              {{ item.majorType }}&nbsp;{{ item.major }}
            </div>
            <div class="jyjl_content_one" style="min-width: 130px">
              {{ item.startTime }}--{{ item.endTime }}
            </div>
            <div
              class="jlxx_moudle_button"
              :class="btns.jyjl ? 'showEdit' : 'showEdit'"
            >
              <p @click="changeFormShow(item, 'jyjl')">修改</p>
            </div>
          </div>
        </div>

        <div class="jlxx_form" v-if="formShow.jyjl">
          <div class="rczp-row">
            <div class="rczp-col">
              <span class="rczp-form-label"
                ><span
                  >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;学历：</span
                ></span
              >
              <input
                placeholder="请输入"
                class="rczp-form-input"
                v-model="form.jyjl.education"
                type="text"
                maxlength="20"
              />
            </div>
            <div class="rczp-col xueliChange" style="">
              <span class="rczp-form-label">学校名称：</span>
              <input
                placeholder="请输入"
                class="rczp-form-input"
                v-model="form.jyjl.schoolName"
                type="text"
                maxlength="20"
              />
            </div>
          </div>
          <div class="rczp-row xueliChange" style="">
            <div class="rczp-col">
              <span class="rczp-form-label"
                ><span
                  >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;专业：<br />所属分类&nbsp;&nbsp;&nbsp;</span
                ></span
              >
              <input
                placeholder="请输入"
                v-model="form.jyjl.majorType"
                class="rczp-form-input"
              />
            </div>
            <div class="rczp-col">
              <span class="rczp-form-label"
                ><span
                  >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;专业：</span
                ></span
              >
              <input
                placeholder="请输入"
                v-model="form.jyjl.major"
                class="rczp-form-input"
              />
            </div>
          </div>
          <div class="rczp-row xueliChange" style="">
            <div class="rczp-col rczp-col-2">
              <span class="rczp-form-label">起止时间：</span>
              <!-- <input
                placeholder="请输入"
                v-model="form.jyjl.startTime"
                class="rczp-form-input"
              /> -->
              <el-date-picker
                v-model="form.jyjl.params"
                class="rczp-form-input"
                type="daterange"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="jlxx_btn">
            <button
              type="button"
              class="common-btn my-btn"
              style="background-color: rgba(241, 83, 82, 1)"
              @click="moudleCancel('jyjl')"
            >
              取消
            </button>
            <button
              type="button"
              class="common-btn my-btn"
              @click="moudleOk('jyjl')"
            >
              保存更新
            </button>
          </div>
        </div>
      </div>

      <div
        class="grzx_common_add_button jlxx_add_button"
        data-type="jyjl"
        @click="changeFormShow(null, 'jyjl')"
      >
        <!-- v-if="addShow.jyjl" -->
        + 添加教育经历
      </div>
    </section>

    <section class="jlxx_gzjl jlxx_line" v-if="currentNav == 'sxjl'">
      <div class="grzx_common_title">工作/实习经历</div>
      <div class="gzjl_moudle">
        <div
          class="jlxx_moudle_one"
          @mouseover="mouseOver('sxjl')"
          @mouseleave="mouseLeave('sxjl')"
          v-for="(item, index) in sxjlList"
          :key="index"
        >
          <div class="jlxx_moudle_first_line">
            <div class="jlxx_moudle_title">{{ item.companyName }}</div>
            <div class="gzjl_content_sj">
              {{ item.startTime }}--{{ item.endTime }}
            </div>
            <div
              class="jlxx_moudle_button"
              :class="btns.sxjl ? 'showEdit' : 'showEdit'"
            >
              <span @click="delForm(item, 'sxjl')">删除</span
              ><span @click="changeFormShow(item, 'sxjl')">修改</span>
            </div>
          </div>
          <div class="gzjl_content">
            <div class="gzjl_content_one">
              职位名称：<span>{{ item.position }}</span>
            </div>
            <div class="gzjl_content_one">
              所属行业：<span>{{ item.industry }}</span>
            </div>
            <div class="gzjl_content_one width_all">
              工作内容：
              <p>{{ item.workContent }}</p>
            </div>
          </div>
        </div>

        <div class="jlxx_form" v-if="formShow.sxjl">
          <div class="rczp-row">
            <div class="rczp-col rczp-col-2">
              <span class="rczp-form-label">企业名称：</span>
              <input
                placeholder="请输入"
                class="rczp-form-input"
                v-model="form.sxjl.companyName"
                type="text"
                maxlength="50"
              />
            </div>
            <div class="rczp-col rczp-col-2">
              <span class="rczp-form-label">在职时间：</span>
              <el-date-picker
                v-model="form.sxjl.params"
                type="daterange"
                class="rczp-form-input"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
              <!-- <div>
                <input
                  placeholder="请选择"
                  class="
                    rczp-form-input
                    iconfont-xndatepicker
                    icon-xndatepickerrili
                    xndatepicker-input
                  "
                  v-model="form.sxjl.startTime"
                  type="text"
                />
              </div> -->
            </div>
          </div>
          <div class="rczp-row">
            <div class="rczp-col rczp-col-2">
              <span class="rczp-form-label">职位名称：</span>
              <input
                placeholder="请输入"
                class="rczp-form-input"
                v-model="form.sxjl.position"
                type="text"
                maxlength="20"
              />
            </div>
            <div class="rczp-col rczp-col-2">
              <span class="rczp-form-label">所属行业：</span>
              <input
                placeholder="请输入"
                v-model="form.sxjl.industry"
                class="rczp-form-input"
              />
            </div>
          </div>
          <div class="rczp-row">
            <div class="rczp-col rczp-col-1">
              <span class="rczp-form-label" style="width: 10%">工作内容：</span>
              <textarea
                placeholder="请输入"
                class="rczp-form-textarea"
                v-model="form.sxjl.workContent"
                rows="5"
                maxlength="200"
              ></textarea>
            </div>
          </div>
          <div class="jlxx_btn">
            <button
              type="button"
              class="common-btn my-btn"
              style="background-color: rgba(241, 83, 82, 1)"
              @click="moudleCancel('sxjl')"
            >
              取消
            </button>
            <button
              type="button"
              class="common-btn my-btn"
              @click="moudleOk('sxjl')"
            >
              保存更新
            </button>
          </div>
        </div>
      </div>
      <div
        class="grzx_common_add_button jlxx_add_button"
        @click="changeFormShow(null, 'sxjl')"
      >
        <!-- v-if="addShow.sxjl" -->
        + 添加工作/实习经历
      </div>
    </section>

    <section class="jlxx_xmjl" v-if="currentNav == 'xmjl'">
      <div class="grzx_common_title">项目经历</div>
      <div class="xmjl_moudle">
        <div
          class="jlxx_moudle_one"
          @mouseover="mouseOver('xmjl')"
          @mouseleave="mouseLeave('xmjl')"
          v-for="(item, index) in xmjlList"
          :key="index"
        >
          <div class="jlxx_moudle_first_line">
            <div class="jlxx_moudle_title">{{ item.projectName }}</div>
            <div class="gzjl_content_sj">
              {{ item.startTime }}-{{ item.endTime }}
            </div>
            <div
              class="jlxx_moudle_button"
              :class="btns.xmjl ? 'showEdit' : 'showEdit'"
            >
              <span @click="delForm(item, 'xmjl')">删除</span
              ><span @click="changeFormShow(item, 'xmjl')">修改</span>
            </div>
          </div>
          <div class="gzjl_content">
            <div class="gzjl_content_one width_all">
              项目描述：
              <p>{{ item.projectInfo }}</p>
            </div>
          </div>
        </div>
        <div class="jlxx_form" v-if="formShow.xmjl">
          <form id="xmjl_form">
            <div class="rczp-row">
              <div class="rczp-col rczp-col-2">
                <span class="rczp-form-label">项目名称：</span>
                <input
                  placeholder="请输入"
                  class="rczp-form-input"
                  type="text"
                  maxlength="50"
                  v-model="form.xmjl.projectName"
                />
              </div>
              <div class="rczp-col rczp-col-2">
                <span class="rczp-form-label">起止时间：</span>
                <el-date-picker
                  v-model="form.xmjl.params"
                  type="daterange"
                  class="rczp-form-input"
                  range-separator="-"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
                <!-- <div>
                  <input
                    placeholder="请选择"
                    class="
                      rczp-form-input
                      iconfont-xndatepicker
                      icon-xndatepickerrili
                      xndatepicker-input
                    "
                    type="text"
                    v-model="form.xmjl.startTime"
                  />
                </div> -->
              </div>
            </div>
            <div class="rczp-row">
              <div class="rczp-col rczp-col-1">
                <span class="rczp-form-label" style="width: 10%"
                  >项目描述：</span
                >
                <textarea
                  placeholder="请输入"
                  class="rczp-form-textarea"
                  rows="5"
                  maxlength="200"
                  v-model="form.xmjl.projectInfo"
                ></textarea>
              </div>
            </div>
            <div class="jlxx_btn">
              <button
                type="button"
                class="common-btn my-btn"
                style="background-color: rgba(241, 83, 82, 1)"
                @click="moudleCancel('xmjl')"
              >
                &nbsp;&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;&nbsp;
              </button>
              <button
                type="button"
                class="common-btn my-btn"
                @click="moudleOk('xmjl')"
              >
                保存更新
              </button>
            </div>
          </form>
        </div>
      </div>

      <div
        class="grzx_common_add_button jlxx_add_button"
        @click="changeFormShow(null, 'xmjl')"
      >
        <!-- v-if="addShow.xmjl" -->
        + 添加项目经历
      </div>
    </section>

    <section class="jlxx_xmjl" v-if="currentNav == 'fj'">
      <div class="grzx_common_title">附件</div>
      <div class="append_content">
        <div class="appendList" v-for="(item, index) in fjList" :key="index">
          <div class="append_image" @click="downloadFile(item)">
            <img
              v-if="
                item.appendUrl.indexOf('jpg') > 0 ||
                item.appendUrl.indexOf('png') > 0 ||
                item.appendUrl.indexOf('jpeg') > 0
              "
              :src="item.appendUrl"
            />
            <img
              v-if="
                item.appendUrl.indexOf('doc') > 0 ||
                item.appendUrl.indexOf('docx') > 0
              "
              src="@/assets/images/word.png"
            />
            <img
              v-if="
                item.appendUrl.indexOf('xls') > 0 ||
                item.appendUrl.indexOf('xlsx') > 0
              "
              src="@/assets/images/excel.jpg"
            />
            <img
              v-if="item.appendUrl.indexOf('pdf') > 0"
              src="@/assets/images/pdf.jpeg"
            />
          </div>
          <div class="append_name">{{ item.name }}</div>
          <div class="append_btn jlxx_moudle_button showEdit">
            <span @click="delForm(item, 'fj')">删除</span
            ><span @click="changeFormShow(item, 'fj')">修改</span>
            <span @click="onDownloadFile(item.appendUrl, item.name)">下载</span>
          </div>
        </div>
      </div>
      <div class="xmjl_moudle">
        <div class="jlxx_form" v-if="formShow.fj">
          <form id="xmjl_form">
            <div class="rczp-row">
              <div class="rczp-col rczp-col-2">
                <span class="rczp-form-label">附件名称：</span>
                <select v-model="form.fj.type">
                  <option selected disabled hidden value=""></option>
                  <option value="学历毕业证">学历毕业证</option>
                  <option value="学信网《教育部学籍在线验证报告》">
                    学信网《教育部学籍在线验证报告》
                  </option>
                  <option value="学士学位证书">学士学位证书</option>
                  <option value="身份证正反面">身份证正反面</option>
                  <option value="职业资格证书">职业资格证书</option>
                  <option value="其他">其他</option>
                </select>
              </div>
              <div class="rczp-col rczp-col-2" v-if="form.fj.type == '其他'">
                <span class="rczp-form-label">附件名称：</span>
                <input
                  placeholder="请输入"
                  class="rczp-form-input"
                  type="text"
                  maxlength="50"
                  v-model="form.fj.name"
                />
              </div>
            </div>
            <div class="rczp-row">
              <div class="rczp-col rczp-col-2">
                <span class="rczp-form-label">附件类型：</span>
                <select v-model="form.fj.fileType">
                  <option selected disabled hidden value=""></option>
                  <option value="1">图片</option>
                  <option value="2">文件</option>
                </select>
              </div>
            </div>
            <div class="rczp-row" v-if="form.fj.fileType == 1">
              <div class="rczp-col rczp-col-1">
                <span class="rczp-form-label" style="width: 10%">附件：</span>
                <el-upload
                  class="avatar-uploader"
                  :action="uploadImgUrl"
                  :show-file-list="false"
                  :on-success="handleUploadSuccess"
                  :before-upload="handleBeforeUpload"
                  :headers="headers"
                  :limit="1"
                  accept=".jpg,.png,.jpeg,.xlsx,.xls,.doc,.docx,.pdf"
                >
                  <img
                    v-if="form.fj.appendUrl"
                    :src="form.fj.appendUrl"
                    class="avatar"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
            </div>
            <div class="rczp-row" v-if="form.fj.fileType == 2">
              <div class="rczp-col rczp-col-1">
                <span class="rczp-form-label" style="width: 10%">附件：</span>
                <el-upload
                  class="upload-demo"
                  :action="uploadImgUrl"
                  :on-success="handleUploadSuccess"
                  :before-upload="handleBeforeUpload"
                  :headers="headers"
                  :file-list="fileList"
                  :limit="1"
                  accept=".xlsx,.xls,.doc,.docx,.pdf"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </div>
            </div>
            <div class="jlxx_btn">
              <button
                type="button"
                class="common-btn my-btn"
                style="background-color: rgba(241, 83, 82, 1)"
                @click="moudleCancel('fj')"
              >
                &nbsp;&nbsp;&nbsp;&nbsp;取消&nbsp;&nbsp;&nbsp;&nbsp;
              </button>
              <button
                type="button"
                class="common-btn my-btn"
                @click="moudleOk('fj')"
              >
                保存更新
              </button>
            </div>
          </form>
        </div>
      </div>

      <div
        class="grzx_common_add_button jlxx_add_button"
        @click="changeFormShow(null, 'fj')"
      >
        + 添加附件
      </div>
    </section>
  </div>
</template>

<script>
import request from "@/request";
export default {
  data() {
    return {
      total: 0,
      pageNum: 1,
      pageSize: 8,
      messageList: [],
      currentNav: "grpj",

      uploadImgUrl: request.uploadFile, // 上传的图片服务器地址
      headers: {
        Authorization: this.$cookies.get(this.$commons.User.Authentication),
      },
      fileType: ["png", "jpg", "jpeg", "xlsx", "xls", "doc", "docx", "pdf"],

      btns: {
        qzyx: false,
        jyjl: false,
        sxjl: false,
        xmjl: false,
        fj: false,
      },
      formShow: {
        qzyx: false,
        jyjl: false,
        sxjl: false,
        xmjl: false,
        fj: false,
      },
      addShow: {
        qzyx: true,
        jyjl: true,
        sxjl: true,
        xmjl: true,
        fj: true,
      },
      navList: [
        { name: "个人评价", id: "grpj" },
        { name: "求职意向", id: "qzyx" },
        { name: "教育经历", id: "jyjl" },
        { name: "工作/实习经历", id: "sxjl" },
        { name: "项目经历", id: "xmjl" },
        { name: "附件", id: "fj" },
      ],
      form: {
        qzyx: {},
        jyjl: {},
        sxjl: {},
        xmjl: {},
        fj: {},
      },
      studentInfo: {},
      //求职意向
      qzyxList: [],
      //教育经历
      jyjlList: [],
      //工作/实习经历
      sxjlList: [],
      //项目经历
      xmjlList: [],
      //附件
      fjList: [],
      //附件类型
      appendType: "",
      fileList: [],
    };
  },
  activated() {
    this.getResume();
  },
  methods: {
    currentNavChange(val) {
      let _this = this;
      _this.currentNav = val.id;
    },
    mouseOver(val) {
      let _this = this;
      _this.btns[val] = true;
    },
    mouseLeave(val) {
      let _this = this;
      _this.btns[val] = false;
    },
    changeFormShow(item, val) {
      let _this = this;
      _this.formShow[val] = true;
      _this.fileList = [];
      if (item) {
        switch (val) {
          case "qzyx":
            _this.getJobPurpose(item);
            break;
          case "jyjl":
            _this.getEducationExperience(item);
            break;
          case "sxjl":
            _this.getWorkExperience(item);
            break;
          case "xmjl":
            _this.getProjectExperience(item);
            break;
          case "fj":
            _this.getFj(item);
            break;
          default:
            console.log("val", val);
        }
      } else {
        _this.form[val] = {};
        _this.addShow[val] = false;
      }
    },
    moudleCancel(val) {
      let _this = this;
      _this.formShow[val] = false;
    },

    getResume() {
      let _this = this;
      _this.$api.employee
        .getResume()
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.studentInfo = res.data.userInfo;
            _this.qzyxList = res.data.qzyx;
            if (_this.qzyxList.length > 0) {
              _this.addShow.qzyx = false;
            }
            _this.jyjlList = res.data.jyjl;
            if (_this.jyjlList.length > 0) {
              _this.addShow.jyjl = false;
            }
            _this.sxjlList = res.data.sxjl;
            if (_this.sxjlList.length > 0) {
              _this.addShow.sxjl = false;
            }
            _this.xmjlList = res.data.xmjl;
            if (_this.xmjlList.length > 0) {
              _this.addShow.xmjl = false;
            }
            _this.fjList = res.data.fj;
          } else {
            _this.$layer.alert(res.msg);
          }
        })
        .catch(() => {})
        .finally(() => {});
    },

    getJobPurpose(item) {
      let _this = this;
      let parm = {
        id: item.id,
      };
      _this.$api.jobPurpose
        .getById(parm)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.form.qzyx = res.data;
          } else {
            _this.$layer.alert(res.msg);
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
    getEducationExperience(item) {
      let _this = this;
      let parm = {
        id: item.id,
      };
      _this.$api.educationExperience
        .getById(parm)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.form.jyjl = res.data;
            _this.form.jyjl.params = [res.data.startTime, res.data.startTime];
          } else {
            _this.$layer.alert(res.msg);
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
    getWorkExperience(item) {
      let _this = this;
      let parm = {
        id: item.id,
      };
      _this.$api.workExperience
        .getById(parm)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.form.sxjl = res.data;
            _this.form.sxjl.params = [res.data.startTime, res.data.startTime];
          } else {
            _this.$layer.alert(res.msg);
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
    getProjectExperience(item) {
      let _this = this;
      let parm = {
        id: item.id,
      };

      _this.$api.projectExperience
        .getById(parm)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.form.xmjl = res.data;
            _this.form.xmjl.params = [res.data.startTime, res.data.startTime];
          } else {
            _this.$layer.alert(res.msg);
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
    getFj(item) {
      let _this = this;
      let parm = {
        id: item.id,
      };
      _this.fileList = [];
      _this.$api.append
        .getById(parm)
        .then((res) => {
          if (res.code == this.$commons.RespCode.success) {
            _this.form.fj = res.data;
            _this.fileList.push({
              name: res.data.appendUrl.substring(
                res.data.appendUrl.lastIndexOf("/") + 1,
                res.data.appendUrl.length
              ),
              url: res.data.appendUrl,
            });
          } else {
            _this.$layer.alert(res.msg);
          }
        })
        .catch(() => {})
        .finally(() => {});
    },
    moudleOk(val) {
      let _this = this;
      switch (val) {
        case "qzyx":
          _this.addOrUpdateQz(val);
          break;
        case "jyjl":
          _this.addOrUpdateJy(val);
          break;
        case "sxjl":
          _this.addOrUpdateSx(val);
          break;
        case "xmjl":
          _this.addOrUpdateXm(val);
          break;
        case "fj":
          _this.addOrUpdateFj(val);
          break;
        default:
          console.log("val", val);
      }
    },
    addOrUpdateQz(val) {
      let _this = this;
      if (!_this.form.qzyx.industry) {
        _this.$layer.alert("请填写期望行业岗位");
        return;
      }
      if (!_this.form.qzyx.address) {
        _this.$layer.alert("请填写期望工作地点");
        return;
      }
      if (!_this.form.qzyx.salary) {
        _this.$layer.alert("请填写期望薪资");
        return;
      }
      if (!_this.form.qzyx.workYear) {
        _this.$layer.alert("请填写工作经验");
        return;
      }
      if (!_this.form.qzyx.workType) {
        _this.$layer.alert("请选择工作性质");
        return;
      }
      if (_this.form[val].id) {
        _this.$api.jobPurpose
          .edit(_this.form[val])
          .then((res) => {
            _this.$layer.alert(res.msg);
            _this.form[val] = {};
            _this.formShow[val] = false;
            _this.getResume();
          })
          .catch(() => {})
          .finally(() => {});
      } else {
        _this.$api.jobPurpose
          .add(_this.form[val])
          .then((res) => {
            _this.$layer.alert(res.msg);
            _this.form[val] = {};
            _this.formShow[val] = false;
            _this.getResume();
          })
          .catch(() => {})
          .finally(() => {});
      }
    },
    addOrUpdateJy(val) {
      let _this = this;
      if (_this.form[val].params.length != 2) {
        _this.$layer.alert("请选择开始或结束时间");
        return;
      }
      if (!_this.form.jyjl.education) {
        _this.$layer.alert("请填写学历");
        return;
      }
      if (!_this.form.jyjl.schoolName) {
        _this.$layer.alert("请填写学校名称");
        return;
      }
      if (!_this.form.jyjl.majorType) {
        _this.$layer.alert("请填写专业所属分类");
        return;
      }
      if (!_this.form.jyjl.major) {
        _this.$layer.alert("请填写专业");
        return;
      }
      _this.form[val].startTime = _this.form[val].params[0];
      _this.form[val].endTime = _this.form[val].params[1];
      delete _this.form[val].params;
      if (_this.form[val].id) {
        _this.$api.educationExperience
          .edit(_this.form[val])
          .then((res) => {
            _this.$layer.alert(res.msg);
            _this.form[val] = {};
            _this.formShow[val] = false;
            _this.getResume();
          })
          .catch(() => {})
          .finally(() => {});
      } else {
        _this.$api.educationExperience
          .add(_this.form[val])
          .then((res) => {
            _this.$layer.alert(res.msg);
            _this.form[val] = {};
            _this.formShow[val] = false;
            _this.getResume();
          })
          .catch(() => {})
          .finally(() => {});
      }
    },
    addOrUpdateSx(val) {
      let _this = this;
      if (_this.form[val].params.length != 2) {
        _this.$layer.alert("请选择开始或结束时间");
        return;
      }
      if (!_this.form.sxjl.companyName) {
        _this.$layer.alert("请填写企业名称!");
        return;
      }
      if (!_this.form.sxjl.position) {
        _this.$layer.alert("请填写职位名称!");
        return;
      }
      if (!_this.form.sxjl.industry) {
        _this.$layer.alert("请填写所属行业!");
        return;
      }
      if (!_this.form.sxjl.workContent) {
        _this.$layer.alert("请填写工作内容!");
        return;
      }
      _this.form[val].startTime = _this.form[val].params[0];
      _this.form[val].endTime = _this.form[val].params[1];
      delete _this.form[val].params;
      if (_this.form[val].id) {
        _this.$api.workExperience
          .edit(_this.form[val])
          .then((res) => {
            _this.$layer.alert(res.msg);
            _this.form[val] = {};
            _this.formShow[val] = false;
            _this.getResume();
          })
          .catch(() => {})
          .finally(() => {});
      } else {
        _this.$api.workExperience
          .add(_this.form[val])
          .then((res) => {
            _this.$layer.alert(res.msg);
            _this.form[val] = {};
            _this.formShow[val] = false;
            _this.getResume();
          })
          .catch(() => {})
          .finally(() => {});
      }
    },
    addOrUpdateXm(val) {
      let _this = this;
      if (_this.form[val].params.length != 2) {
        _this.$layer.alert("请选择开始或结束时间");
        return;
      }
      if (!_this.form.xmjl.projectName) {
        _this.$layer.alert("请填写项目名称!");
        return;
      }
      if (!_this.form.xmjl.projectInfo) {
        _this.$layer.alert("请填写项目描述!");
        return;
      }
      _this.form[val].startTime = _this.form[val].params[0];
      _this.form[val].endTime = _this.form[val].params[1];
      delete _this.form[val].params;
      if (_this.form[val].id) {
        _this.$api.projectExperience
          .edit(_this.form[val])
          .then((res) => {
            _this.$layer.alert(res.msg);
            _this.form[val] = {};
            _this.formShow[val] = false;
            _this.getResume();
          })
          .catch(() => {})
          .finally(() => {});
      } else {
        _this.$api.projectExperience
          .add(_this.form[val])
          .then((res) => {
            _this.$layer.alert(res.msg);
            _this.form[val] = {};
            _this.formShow[val] = false;
            _this.getResume();
          })
          .catch(() => {})
          .finally(() => {});
      }
    },
    addOrUpdateFj(val) {
      let _this = this;
      if (!_this.form[val].type) {
        _this.$layer.alert("请选择附件名称");
        return;
      }
      if (_this.form[val].type == "其他" && !_this.form[val].name) {
        _this.$layer.alert("请输入附件名称");
        return;
      }
      if (!_this.form[val].appendUrl) {
        _this.$layer.alert("请上传附件");
        return;
      }
      if (_this.form[val].type != "其他") {
        _this.form[val].name = _this.form[val].type;
      }
      if (_this.form[val].id) {
        _this.$api.append
          .edit(_this.form[val])
          .then((res) => {
            _this.$layer.alert(res.msg);
            _this.form[val] = {};
            _this.formShow[val] = false;
            _this.getResume();
          })
          .catch(() => {})
          .finally(() => {});
      } else {
        _this.$api.append
          .add(_this.form[val])
          .then((res) => {
            _this.$layer.alert(res.msg);
            _this.form[val] = {};
            _this.formShow[val] = false;
            _this.getResume();
          })
          .catch(() => {})
          .finally(() => {});
      }
    },
    delForm(item, val) {
      let _this = this;
      let parm = {
        id: item.id,
      };
      _this.$layer.confirm(
        "确认要执行删除操作吗?",
        {
          btn: ["确定", "取消"], // 按钮
        },
        function (index) {
          if (val == "sxjl") {
            _this.$api.workExperience
              .deleteById(parm)
              .then((res) => {
                _this.$layer.alert(res.msg);
                _this.form[val] = {};
                _this.formShow[val] = false;
                _this.getResume();
              })
              .catch(() => {})
              .finally(() => {});
          } else if (val == "xmjl") {
            _this.$api.projectExperience
              .deleteById(parm)
              .then((res) => {
                _this.$layer.alert(res.msg);
                _this.form[val] = {};
                _this.formShow[val] = false;
                _this.getResume();
              })
              .catch(() => {})
              .finally(() => {});
          } else if (val == "fj") {
            _this.$api.append
              .deleteById(parm)
              .then((res) => {
                _this.$layer.alert(res.msg);
                _this.form[val] = {};
                _this.formShow[val] = false;
                _this.getResume();
              })
              .catch(() => {})
              .finally(() => {});
          }

          _this.$layer.close(index);
        },
        function (index) {
          _this.$layer.close(index);
        }
      );
    },
    editGrpj() {
      let _this = this;

      _this.$api.employee
        .updateUserInfo(_this.studentInfo)
        .then((res) => {
          _this.$layer.alert(res.msg);
          _this.getResume();
        })
        .catch(() => {})
        .finally(() => {});
    },

    // 上传成功回调
    handleUploadSuccess(res) {
      let _this = this;
      this.fileList = [];
      this.fileList.push({ name: res.data.url, url: res.data.url });
      _this.form.fj.appendUrl = res.data.url;
      _this.$forceUpdate();
      _this.$modal.closeLoading();
    },
    // 上传前loading加载
    handleBeforeUpload(file) {
      let isImg = false;
      if (this.fileType.length) {
        let fileExtension = "";
        if (file.name.lastIndexOf(".") > -1) {
          fileExtension = file.name.slice(file.name.lastIndexOf(".") + 1);
        }
        isImg = this.fileType.some((type) => {
          if (file.type.indexOf(type) > -1) return true;
          if (fileExtension && fileExtension.indexOf(type) > -1) return true;
          return false;
        });
      } else {
        isImg = file.type.indexOf("image") > -1;
      }

      if (!isImg) {
        this.$modal.msgError(
          `文件格式不正确, 请上传${this.fileType.join("/")}格式文件!`
        );
        return false;
      }
      const isLt = file.size / 1024 / 1024 <5;
      if (!isLt) {
        this.$modal.msgError(`上传文件大小不能超过 5MB!`);
        return false;
      }

      this.$modal.loading("正在上传文件，请稍候...");
    },
    downloadFile(item) {
      let _this = this;
      if (item.fileType == 1) {
        _this.$layer.open({
          type: 2,
          title: false,
          closeBtn: 0,
          area: ["80%", "80%"],
          skin: "layui-layer-nobg", //没有背景色
          shadeClose: true,
          content: item.appendUrl,
        });
      }
    },
    onDownloadFile(url, fileName) {
      this.getBlob(url, (blob) => {
        this.saveAs(blob, fileName);
      });
    },
    getBlob(url, cb) {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url, true);
      xhr.responseType = "blob";
      xhr.onload = function () {
        if (xhr.status === 200) {
          cb(xhr.response);
        }
      };
      xhr.send();
    },

    saveAs(blob, filename) {
      if (window.navigator.msSaveOrOpenBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        var link = document.createElement("a");
        var body = document.querySelector("body");

        link.href = window.URL.createObjectURL(blob);
        link.download = filename;

        link.style.display = "none";
        body.appendChild(link);

        link.click();
        body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      }
    },
  },
};
</script>

<style>
.showEdit {
  opacity: 1 !important;
}
.el-upload__input {
  display: none !important;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px !important;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
select {
  width: 300px;
  background: #f8f8f8;
  border: 1px solid #ededed;
  padding: 8px 0 8px 10px;
  border-radius: 4px;
}
.append_content {
  margin: 40px auto !important;
  width: 890px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.appendList {
  display: flex;
  flex-flow: column;
  margin-right: 20px;
  margin-bottom: 20px;
  width: 270px;
  height: 206px;
  background-color: #ffffff;
  box-shadow: 0px 2px 4px rgb(208 208 208 / 50%);
  border-radius: 10px;
  transition: all 0.2s;
  padding-top: 10px;
}
.appendList:hover {
  cursor: pointer;
  box-shadow: 10px 6px 40px rgb(208 208 208);
}
.append_image {
  height: 128px;
  width: 250px;
  /* background-color: #00F7DE; */
  margin: auto;
}
.append_image img {
  height: 100%;
  max-width: 100%;
}
.append_name {
  height: 30px;
  width: 250px;
  margin: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  transition: all 0.2s;
}
.append_btn {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
  align-content: center;
  padding: 5px;
}
.appendList:hover .append_name {
  color: #409eff !important;
  transform: scale(1.02);
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/view/mine/mineResume.vue